module.exports = "<Form>\n  <Form.Group>\n    <Form.File id=\"exampleFormControlFile1\" label=\"Example file input\" />\n  </Form.Group>\n</Form>;\n"